/* global axios */
import ApiClient from './ApiClient';

class PipelineBoardsAPI extends ApiClient {
  constructor() {
    super('pipeline_boards', { accountScoped: true });
  }

  getBoards() {
    return axios.get(this.url);
  }

  getBoard(boardId, params = {}) {
    return axios.get(`${this.url}/${boardId}`, { params });
  }

  createBoard(board) {
    return axios.post(this.url, { pipeline_board: board });
  }

  createBoardFromTemplate(board) {
    return axios.post(`${this.url}/create_from_template`, {
      pipeline_board: board,
    });
  }

  moveBoardCard(boardId, cardId, stageId, position) {
    return axios.post(`${this.url}/${boardId}/move`, {
      card_id: cardId,
      stage_id: stageId,
      position,
    });
  }
}

export default new PipelineBoardsAPI();
